import React from 'react'

const Loading = () => {
    return (
        <div className="loading-container">
             <i className="fas fa-umbrella-beach"></i>
        </div>
    )
}

export default Loading
